module.exports = __webpack_public_path__ + "media/img/event/Ace-EDM-94f44fd7fa53c715e3ab25368f0785ed.jpg";